import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as userActions from "../../actions/userActions";

import ForgotForm from "./ForgotForm";
// import "../../styles/styles-light.scss";

class ForgotPage extends Component {
  handleSave = (user) => {
    this.props.actions.forgotPassword(user);
  };

  render() {
    const { savingUser } = this.props;
    return (
      <div className="login-page">
        <ForgotForm onSave={this.handleSave} saving={savingUser} />
      </div>
    );
  }
}

ForgotPage.propTypes = {
  actions: PropTypes.object.isRequired,
  savingUser: PropTypes.bool
};

function mapStatesToProps(state) {
  return {
    state,
    savingUser: state.reducers.savingUser
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...userActions }, dispatch)
  };
}

export default connect(mapStatesToProps, mapDispatchToProps)(ForgotPage);
